import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { Connection, HttpHeaders, clusterApiUrl } from '@solana/web3.js';
import { Metaplex } from "@metaplex-foundation/js";
import { ALGO_NETWORK } from '../../constants/constants';
import { API_HOST } from '../../constants/constants';

export const solanaNetwork = ALGO_NETWORK === 'MainNet' ? WalletAdapterNetwork.Mainnet : WalletAdapterNetwork.Devnet;

const makeApiUrl = (path: string) => new URL(path, API_HOST).toString();

const SOLANA_PROXY_RPC_PUBLIC = makeApiUrl('/system/rpc/solana/public');
const SOLANA_PROXY_RPC = makeApiUrl('/system/rpc/solana');

export class SolanaNetwork {
  static endpoint = SOLANA_PROXY_RPC_PUBLIC;
  static connection = new Connection(SolanaNetwork.endpoint, { commitment: 'confirmed' });
  static metaplex = new Metaplex(SolanaNetwork.connection);
  static updateConnection = (httpHeaders?: HttpHeaders) => {
    if (httpHeaders) {
      SolanaNetwork.connection = new Connection(SOLANA_PROXY_RPC, { commitment: 'confirmed', httpHeaders });
    } else {
      SolanaNetwork.connection = new Connection(SOLANA_PROXY_RPC_PUBLIC, { commitment: 'confirmed' });
    }
  }
}
